import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
      // Start with granted by default for essential cookies
      if (window.gtag) {
        window.gtag('consent', 'default', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted'
        });
      }
    } else if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted'
      });
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted'
      });
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left flex-1">
          {t('cookieConsent.message', 'Bu web sitesi deneyiminizi geliştirmek için çerezleri kullanır. Devam ederek çerez kullanımını ve gizlilik politikamızı kabul etmiş olursunuz.')}
        </p>
        <button
          onClick={handleAccept}
          className="px-6 py-2 text-sm bg-white text-gray-900 rounded hover:bg-gray-100 transition-colors font-medium"
        >
          {t('cookieConsent.ok', 'Tamam')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;